import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "redux";
import { connect } from "react-redux";
import { Page, NamedLink } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import TopbarContainer from "../TopbarContainer/TopbarContainer";
import { manageDisableScrolling, isScrollingDisabled } from "../../ducks/ui.duck";
import FooterComponent from "../FooterContainer/FooterContainer";
import RecentListings from "../LandingPage/RecentListings/RecentListings";
import TrustBanner from "./TrustBanner";
import AccountDeletedNotice from "./AccountDeletedNotice/AccountDeletedNotice";

import css from './CustomLandingPage.module.css';
import HeroCollage from './heroCollage.png';
import Devices from './devices-card.png';
import StepOne from './step1.png';
import StepTwo from './Step2.png';
import StepThree from './step3.png';

import PaypalFee from './paypal_fee.svg';
import PlatformFee from './platform_fee.svg'

const LandingPageComponent = (props) => {
    const { scrollingDisabled } = props;
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

    return (
        <Page title="Home" scrollingDisabled={scrollingDisabled}>
            <TopbarContainer
                mobileRootClassName={css.mobileTopbar}
                desktopClassName={css.desktopTopbar}
                mobileClassName={css.mobileTopbar}
            />
            <div className={css.pageWrapper}>
                <div className={css.firstBox}>
                    <div className={css.heroInner}>
                        <div className={css.contentWrapper}>
                            <p className={css.eyebrow}>
                                <FormattedMessage id="CustomLandingPage.heroEyebrow" />
                            </p>
                            <h1 className={css.title}>
                                <FormattedMessage id="CustomLandingPage.heroTitle" />
                            </h1>
                            <p className={css.subDesc}><FormattedMessage id="CustomLandingPage.desc" /></p>
                            <NamedLink name="SearchPage" className={css.browseCards}>
                                <FormattedMessage id="CustomLandingPage.browse" />
                                <span aria-hidden="true">→</span>
                            </NamedLink>
                        </div>
                        <div className={css.imageWrapper}>
                            <img src={HeroCollage} className={css.heroImage} alt="" />
                        </div>
                    </div>
                </div>
                <div className={css.recentListingsSection}>
                    <RecentListings />
                </div>
                <hr className={css.sectionDivider} />
                <div className={css.selection}><FormattedMessage id="CustomLandingPage.selection" /></div>
                <div className={css.selectionDesc}><FormattedMessage id="CustomLandingPage.selectionDesc" /></div>
                <div className={css.thirdBox}>
                    <div className={css.leftBox}>
                        <div className={css.lowerFees}><FormattedMessage id="CustomLandingPage.lowerFees" /></div>
                        <div className={css.buyingAndSelling}><FormattedMessage id="CustomLandingPage.buyingAndSelling" /></div>
                        <div className={css.feeWrapper}>
                            <img src={PaypalFee} className={css.feeIcon} />
                            <img src={PlatformFee} className={css.feeIcon} />
                        </div>
                    </div>
                    <img src={Devices} className={css.devicesImg} />
                </div>
                <div className={css.fourthBox}>
                    <div className={css.how}><FormattedMessage id="CustomLandingPage.how" /></div>
                    <div className={css.gettingStarted}><FormattedMessage id="CustomLandingPage.gettingStarted" /></div>
                    <div className={css.threeImages}>
                        <div className={css.imgWithText1}>
                            <img src={StepOne} className={css.stepOneImg} />
                            <div className={css.createAccount}><FormattedMessage id="CustomLandingPage.createAcc" /></div>
                            <div className={css.createAccDesc}><FormattedMessage id="CustomLandingPage.createAccDesc" /></div>
                        </div>
                        <div className={css.imgWithText2}>
                            <img src={StepTwo} className={css.stepTwoImg} />
                            <div className={css.step2}><FormattedMessage id="CustomLandingPage.find" /></div>
                            <div className={css.step2Desc}><FormattedMessage id="CustomLandingPage.findDesc" /></div>
                        </div>
                        <div className={css.imgWithText3}>
                            <img src={StepThree} className={css.stepThreeImg} />
                            <div className={css.step3}><FormattedMessage id="CustomLandingPage.buyAndRecieve" /></div>
                            <div className={css.step3Desc}><FormattedMessage id="CustomLandingPage.step3Desc" /></div>
                        </div>
                    </div>
                    {!isMobile ?
                        <NamedLink name="SearchPage" className={css.browseCardNow}>
                            <FormattedMessage id="CustomLandingPage.browseCardNow" />
                        </NamedLink>
                        : null}
                </div>
                <div className={css.fifthBox}>
                    <div className={css.btnAndTextWrapper}>
                        <div>
                            <div className={css.cardsToSell}><FormattedMessage id="CustomLandingPage.cardsToSell" /></div>
                            <div className={css.collectionDesc}><FormattedMessage id="CustomLandingPage.turnYourCollection" /></div>
                        </div>
                        <NamedLink name="NewListingPage" className={css.startSelling}>
                            <FormattedMessage id="CustomLandingPage.startSellingBtn" />
                        </NamedLink>
                    </div>
                </div>
            </div>
            <TrustBanner />
            <FooterComponent />
            <AccountDeletedNotice />
        </Page>
    );
};

const mapStateToProps = state => ({
    scrollingDisabled: isScrollingDisabled(state),
});

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const CustomLandingPage = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)(LandingPageComponent);

export default CustomLandingPage;